import * as React from "react";
import { Switch, Route } from "react-router-dom";
import { PrivateRoute, PrivateRouteAllStudies } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { StudiesList } from "./StudiesList";
import { PopulationGroupsList } from "../PopulationGroups/PopulationGroupsList";
import { CreatePopulationGroupScreen } from "../PopulationGroups/CreatePopulationGroupScreen";
import { CreateStudyScreen } from "./CreateStudyScreen";
import { EditStudyScreen } from "./EditStudyScreen";
import { FvcSettings } from "./Settings/FvcSettings";
import { SvcSettings } from "./Settings/SvcSettings";
import { PcfSettings } from "./Settings/PcfSettings";
import { EcgSettings } from "./Settings/EcgSettings";
import { DlcoSettings } from "./Settings/DlcoSettings";
import { DiarySettings } from "./Settings/DiarySettings";
import { CoughSettings } from "./Settings/CoughSettings";
import { DcfSettings } from "./Settings/DcfSettings";
import { LungVolumeSettings } from "./Settings/LungVolumeSettings";
import { MipSettings } from "./Settings/MipSettings";
import { SessionTypes } from "../../misc/api/ApiSessionTypes";
import { EditPopulationGroupScreen } from "../PopulationGroups/EditPopulationGroupScreen";
import { MepSettings } from "./Settings/MepSettings";
import { SnipSettings } from "./Settings/SnipSettings";
import { StudyCustomisationScreen } from "./StudyCustomisationScreen";
import { PulseOximetrySettings } from "./Settings/PulseOximetrySettings";
import { PefSettings } from "./Settings/PefSettings";

export const StudiesScreen = () => {
    return (
        <Switch>
            <PrivateRouteAllStudies exact path="/studies" permissions={[PermissionEnum.ViewStudies]}>
                <StudiesList />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies exact path="/studies/create" permissions={[PermissionEnum.CreateStudy]}>
                <CreateStudyScreen />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/edit/:id" permissions={[PermissionEnum.EditStudy]}>
                <EditStudyScreen />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/populationgroups/create" permissions={[PermissionEnum.CreatePopulationGroups]}>
                <CreatePopulationGroupScreen />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/populationgroups/edit/:id" permissions={[PermissionEnum.EditPopulationGroups]}>
                <EditPopulationGroupScreen />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/populationgroups/:id" permissions={[PermissionEnum.ViewPopulationGroups]}>
                <PopulationGroupsList />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/FvcSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <FvcSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/SvcSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <SvcSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/PcfSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <PcfSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/EcgSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <EcgSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/DlcoSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <DlcoSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/DiarySettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <DiarySettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/CoughSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <CoughSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/DcfSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <DcfSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/LungVolumeSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <LungVolumeSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/MipSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <MipSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/MepSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <MepSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/SnipSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <SnipSettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/customisation/:id" permissions={[PermissionEnum.CustomiseStudy]}>
                <StudyCustomisationScreen />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies  path="/studies/pulseoximetrysettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <PulseOximetrySettings />
            </PrivateRouteAllStudies>
            <PrivateRouteAllStudies path="/studies/PefSettings/:id" permissions={[PermissionEnum.EditStudy]}>
                <PefSettings />
            </PrivateRouteAllStudies>
        </Switch>
    );
}
